import type { FaireBrandEntity } from "../../entity_types/brand";

// MALWEST design — real Faire brand (b_cm6qg8te3j). Identity metadata from
// ANALYTICS.CANONICAL.BRANDS; backs the ads-manager-2 "MALWEST design"
// real-brand variant (advertiser -5243943702272902340).
export const b_cm6qg8te3j: FaireBrandEntity = {
  token: "b_cm6qg8te3j",
  type: "brand",
  name: "MALWEST design",
  description: "Greeting cards, stationery, and paper goods.",
  location: "Pensacola, FL, USA",
  isTopShop: true,
  tags: ["paper-novelty", "greeting-cards", "stationery"],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-10T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
